import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import HotelRoom from "../types/HotelRoom";
import {SalesChannelEnum} from "../../common/enums/SalesChannelEnum";

type Output = HotelRoom[];

  interface RoomQueryOptions extends CacheQueryOpts {
    salesChannel?: SalesChannelEnum;
  }

export default function useHotelGetRoomsInfo (
    hotelId: any,
    startOn: any,
    endOn: any,
    options?: RoomQueryOptions
): CacheQueryOutput<Output> {
    const client = useAPIClient();
    const { salesChannel = SalesChannelEnum.WEB, ...cacheOptions } = options || {};

    return useCacheQuery<Output>(
        ["hotel-room-by-hotel", hotelId, salesChannel, startOn, endOn], // Include in cache key
        () => {
            return client.get<any>(`hotel_events/${hotelId}/rooms`, {
                "itemsPerPage": 100,
                "order[orderPosition]": 'ASC',
                "startOn": startOn,
                "endOn": endOn,
                "salesChannel": salesChannel // Always include salesChannel with default value
        });
      },
      cacheOptions
    );
}